export enum GlobalConfigType {
  LoanStatus = 'LoanStatus',
  LoanFields = 'LoanFields',
  PagePermissions = 'PagePermissions',
  Footer = 'Footer',
  AcceptedFileTypes = 'AcceptFileTypes',
  ConditionTypes = 'ConditionTypes',
  DocumentCategory = 'DocumentCategory',
  GlobalSettingV2 = 'GlobalSettingV2',
  LoanSubmissionHierarchy = 'LoanSubmissionHierarchy',
  GUARANTER_CONFIG = 'GUARANTER_CONFIG',
  ORDER_VALUATION = 'ORDER_VALUATION',
  ACCOUNT_TYPES = 'ACCOUNT_TYPES',
  PARTIES = 'PARTIES',
  EMAIL_OPTIONS = 'EMAIL_OPTIONS',
  GTM = 'GTM',
}
